
















































































































import {myVue} from "@/components/class/myVue";
import {Component } from 'vue-property-decorator';
import * as utils from "@/components/util/utils";
@Component
export default class HelloWorld extends myVue {
    data() {
        return {
            tableData: [{
                date: '2016-05-02',
                no: '王小虎',
                tag: '签封样'
            }, {
                date: '2016-05-04',
                no: '王小虎',
                address: '上海市普陀区金沙江路 1517 弄',
                tag: '组装图'
            }, {
                date: '2015-05-01',
                no: '王小虎',
                address: '上海市普陀区金沙江路 1519 弄',
                tag: '工艺单'
            }, {
                date: '2016-05-03',
                no: '王小虎',
                address: '上海市普陀区金沙江路 1516 弄',
                tag: '以往报告'
            }, {
                date: '2016-05-03',
                no: '王小虎',
                address: '上海市普陀区金沙江路 1516 弄',
                tag: '质量整改'
            }],
        }
    }

    my_open(){
        this.current.open()
    }
    my_close(){
        this.current.close()
    }
    cellClick (row:any, column:any, cell:any, event:any) {
        this.current.selectRowOnly = row
        // if(column.label == "文件编号"){
        //     if(row.file_type == "签封样"){
        //         let edit = utils.getStore().openDialog({name:'examine2',title:"查看"})
        //         edit.queryThree()
        //     }else if(row.file_type == "组装图"){
        //         let edit = utils.getStore().openDialog({name:'examine4',title:"查看"})
        //         edit.queryThree()
        //     }else if(row.file_type == "工艺单"){
        //         let edit = utils.getStore().openDialog({name:'examine3',title:"查看"})
        //         edit.queryThree()
        //     }
        // }
    }
    cell_style({ row, column, rowIndex, columnIndex }:any) {
        // if(columnIndex === 3){
        //     if(row.file_type == "签封样" || row.file_type == "组装图" || row.file_type == "工艺单") {
        //             return {'background-color':"#CEFFCE"};
        //     }
        // }
    }
    arraySpanMethod({ row, column, rowIndex, columnIndex }:any) {
            if (columnIndex === 1) {
                return [1, 2];
            }else if(columnIndex === 2){
                return [2,2];
            }
    }

    filterHandler(value:any, row:any, column:any) {
        const property = column['property'];
        let date = row[property];
        let arr = date.split("-")
        let d = new Date();
        d.setFullYear(arr[0],arr[1],arr[2]);
        return d.getFullYear() == value;
    }
    myBtnList (data:any) {
        let list =[]
        for(let i=0;i<this.current.tableBtn.length;i++){
            let item = this.current.tableBtn[i];
            let bool = utils.isJurisdiction({
                process:item.process,
                jurisdictionList:item.jurisdictionJson,
                data:{row:data.row}
            })
            if(bool){
                list.push(item)
            }
        }
        return list
    }
    myBtnOne (data:any) {
        let list = this.myBtnList(data);
        if(list.length>0){
            return list[0]
        }else{
            return {}
        }
    }
    handleSizeChange (val:any) {         // 更新查询的行数
        this.current.rows = val
        this.current.Requery()
    }
    handleCurrentChange (val:any) {            // 更新查询的页数
        this.current.currentPage = val
        this.current.Requery()
    }
    public_click (data:any) {
        this.current.selectRowOnly = data.row
        data.item.click({row:data.row})
    }
}
